export default "__VITE_ASSET__HK2xc$L4__"